/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Style_ActionInputs */

const cs_templates_ai_style_action = /** @type {(inputs: Templates_Ai_Style_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít styl`)
};

const en_templates_ai_style_action = /** @type {(inputs: Templates_Ai_Style_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply style`)
};

/**
* | output |
* | --- |
* | "Apply style" |
*
* @param {Templates_Ai_Style_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_style_action = /** @type {((inputs?: Templates_Ai_Style_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Style_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_style_action(inputs)
	return cs_templates_ai_style_action(inputs)
});